import styled from 'styled-components';
import { Colors } from 'styles/constants';

export const PageContainer = styled.div`
  display: flex;
  background: ${Colors.Gray20};
`;

export const Backdrop = styled.div`
  width: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin: 0 auto;
  gap: 48px;

  @media (max-width: 1800px) {
    column-gap: 24px;
  }
`;

export const LeftPanelSlot = styled.div`
  width: min-content;
`;

export const MainSlot = styled.div`
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  padding: 24px 24px 24px 0;
  max-width: 100%;
  width: 1px;
`;

export const ChildrenSlot = styled.main`
  /* animation: ContentSlideIn 1000ms ease forwards; */
`;
